import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useOnboardingCheck } from '../Onboarded';
import { useConciergeCheck } from '../IsConcierge';

interface OnboardedRouteProps {
  children: React.ReactNode;
}

const OnboardedRoute: React.FC<OnboardedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const navigate = useNavigate();
  const onboarded = useOnboardingCheck();
  const [loadingStatus, setLoadingStatus] = useState(true);
  const isConcierge = useConciergeCheck();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  useEffect(() => {
    const checkUserIsOnboarded = async () => {
      try {
        onboarded.then(isOnboarded => {
          if (isOnboarded) {
            setLoadingStatus(false);
            return;
          } else {
            if(isConcierge) {
              navigate("/concierge-dashboard");
            } else {
              navigate("/onboarding/agreement");
            }
          }
        })
      } catch (error: any) {
        navigate("/error", { 
              state: { 
                error: error?.response?.data || "An error occurred while validating the user"
              } 
            });
            return;
      }
    };
    checkUserIsOnboarded();
  },[onboarded, navigate, isConcierge]);

  if (isLoading || loadingStatus) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 text-center">Checking User...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated && !isLoading) {
    return <div></div>
  }

  return <>{children}</>;
};

export default OnboardedRoute; 